import {Component, forwardRef, Injector, Input, OnInit} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {MeasureSearchModel} from "../measure-search.model";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {MeasureSearchPageComponent} from "../measure-search-page/measure-search-page.component";
import {MeasureEditPageComponent} from "../measure-edit-page/measure-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";


const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MeasureSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-measure-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(MeasureSearchModel)
    ]
})

export class MeasureSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<MeasureSearchModel> implements OnInit {
    @Input() showConvertibleMeasures: boolean;
    @Input() base: boolean;
    private _inventoryMeasureId: number;

    constructor(model: MeasureSearchModel, injector: Injector) {
        super(model, injector, "measureId", "symbol");

        this.allowClearSelectionOption = false;
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.model.setFilterValue("showConvertibleMeasures", this.showConvertibleMeasures);
        this.model.setFilterValue("base", this.base);

        // If only base measures are being shown then we do not need search and add functionality
        if (!this.base) {
            this.extendedSearchComponent = MeasureSearchPageComponent;
            this.extendedEditComponent = MeasureEditPageComponent;
        }
    }

    @Input()
    set inventoryMeasureIdentifier(value: number) {
        this._inventoryMeasureId = value;
        if (this._inventoryMeasureId) {
            this.model.filter["measureId"] = value;
            this.model.setFilterValue("showConvertibleMeasures", this.showConvertibleMeasures);
            this.model.setFilterValue("base", this.base);
        }
    }
}



